<script lang="ts">
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import { A11y } from "$components/+blocks/OVIcon";
  import { createEventDispatcher } from "svelte";
  import cx from "classnames";

  export let value: string | undefined = undefined;
  export let placeholder: string;
  export let label: string;
  export let icon = A11y;

  const dispatch = createEventDispatcher();
</script>

<div
  class="flex w-full items-center gap-1 rounded-md border bg-white p-1.5 text-sm transition-colors focus-within:border-gray-400 dark:border-white/10 dark:bg-neutral-900 dark:focus-within:border-white/30"
>
  <div class="pointer-events-none relative h-5 min-w-[26px] overflow-hidden">
    <OVIcon
      {icon}
      size="size-6"
      class={cx(
        "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform p-1 text-gray-400 opacity-100 transition-all delay-[45ms] duration-200 hover:cursor-pointer dark:text-gray-400"
      )}
    />
  </div>

  <label class="sr-only" for="textInput">{label}</label>
  <input
    id={`textInput-${label.replace(/\s+/g, "-")}`}
    class="w-full border-0 bg-inherit py-0 text-xs font-medium text-gray-500 placeholder-gray-400/80 focus:outline-none dark:text-gray-300 dark:placeholder-gray-400/70"
    {placeholder}
    bind:value
    on:input={() => dispatch("change", value)}
  />
</div>
